import { Component, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { MatLegacyDialogRef as MatDialogRef } from '@angular/material/legacy-dialog';
import { catchError, noop, of, tap } from 'rxjs';

import { OnDestroyMixin, untilComponentDestroyed } from '@w11k/ngx-componentdestroyed';
import { DashboardType } from '../dashboard.types';
import { DashboardService } from 'app/modules/dashboard/dashboard.service';

@Component({
  selector: 'dashboard-add',
  templateUrl: './add.component.html',
  styleUrls: ['./add.component.scss'],
})
export class DashboardAddComponent extends OnDestroyMixin implements OnInit {
  addDashboardForm: UntypedFormGroup;
  message: any;
  isLoading: boolean;

  get isSaveBtnDisabled(): boolean {
    return this.isLoading || this.addDashboardForm.pristine || this.addDashboardForm.invalid;
  }

  constructor(
    private readonly matDialogRef: MatDialogRef<DashboardAddComponent>,
    private readonly dashboardService: DashboardService,
    private readonly router: Router,
    private readonly formBuilder: UntypedFormBuilder,
  ) {
    super();
    this.message = null;
  }

  ngOnInit(): void {
    this.addDashboardForm = this.formBuilder.group({
      name: ['', [Validators.required]],
      description: [''],
    });
  }

  saveAndClose(): void {
    const dashboard = this.addDashboardForm.getRawValue();

    dashboard.dashboard_type = DashboardType.Legacy;

    if (!dashboard?.name?.trim().length) {
      dashboard.name = 'Untitled';
    }

    dashboard.definition = JSON.stringify({
      charts: [
        [
          {
            id: '1',
            title: 'Deals by status',
            chart_type: 'bar',
            summary_type: 'total',
            summary_value: 'id',
            group_by: 'project_stage_id',
            data: {},
          },
        ],
      ],
    });

    dashboard.dashboard_type = DashboardType.Report;
    dashboard.definition = JSON.stringify({ report_ids: [] });

    this.dashboardService
      .createDashboard(dashboard)
      .pipe(
        untilComponentDestroyed(this),
        tap((dash) => {
          this.router.navigate(['/dashboard/', dash.id]);
          this.discard();
        }),
        catchError((response) => {
          // Show the error message
          this.message = {
            appearance: 'outline',
            content: response.error.message,
            showIcon: false,
            type: 'error',
          };

          return of(response);
        }),
      )
      .subscribe(noop);
  }

  discard(): void {
    this.matDialogRef.close();
  }

  // Function attached to debounce-click directive to flag the button's disable state.
  isDebounceLoading(isLoading: boolean): boolean {
    return (this.isLoading = isLoading);
  }
}
